define(["require", "exports", "tslib", "mobx", "../EntityBase", "../entity/FAssetAttrType", "../entity/FAssetType"], function (require, exports, tslib_1, mobx_1, EntityBase_1, FAssetAttrType_1, FAssetType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityReferenceData = void 0;
    class FacilityReferenceData extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AssetAttributeTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetAttributeTypesError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypesError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FacilityReferenceData.ObservableFields);
        }
        onCreate() {
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
        }
        onRead(entity) {
            this.AssetAttributeTypes = [];
            if (entity.AssetAttributeTypes) {
                for (let i = 0; i < entity.AssetAttributeTypes.length; i++) {
                    this.AssetAttributeTypes[i] = new FAssetAttrType_1.FAssetAttrType(entity.AssetAttributeTypes[i]);
                }
            }
            this.AssetTypes = [];
            if (entity.AssetTypes) {
                for (let i = 0; i < entity.AssetTypes.length; i++) {
                    this.AssetTypes[i] = new FAssetType_1.FAssetType(entity.AssetTypes[i]);
                }
            }
        }
        onReady() {
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.AssetAttributeTypes = this.mergeArray(a.AssetAttributeTypes, b.AssetAttributeTypes, FAssetAttrType_1.FAssetAttrType);
            a.AssetTypes = this.mergeArray(a.AssetTypes, b.AssetTypes, FAssetType_1.FAssetType);
            this.postMerge();
        }
        postMerge() {
        }
        serialise() {
            return JSON.stringify(this);
        }
        hasChanges() {
            return this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED;
        }
        validate() {
            return null;
        }
        toJson() {
            return {
                AssetAttributeTypes: this.AssetAttributeTypes.map(x => x.toJson()),
                AssetTypes: this.AssetTypes.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.FacilityReferenceData = FacilityReferenceData;
    Object.defineProperty(FacilityReferenceData, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["AssetAttributeTypes", "AssetTypes"]
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityReferenceData.prototype, "AssetAttributeTypes", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityReferenceData.prototype, "AssetAttributeTypesError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityReferenceData.prototype, "AssetTypes", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityReferenceData.prototype, "AssetTypesError", void 0);
});
